import React, { ReactElement } from 'react';
import { INVENTORY_MESSAGE_CONSTANTS, INVENTROY_CONSTANTS } from '../../../../shared/constants/commonConstants';
import { extractSecondLevelBaseUrl } from '../../../../utils/utility';
import IPPackageForm from './IPPackageForm';

const NewIPPackage = ({ match: { path } }: any): ReactElement => {
  return (
    <div>
      <IPPackageForm
        backUrl={extractSecondLevelBaseUrl(path) + INVENTROY_CONSTANTS.ipPackagesRoute}
        pageTitle={INVENTORY_MESSAGE_CONSTANTS.title.newIp}
        path={path} />
    </div>
  );
};

export default NewIPPackage;
